<template>
    <el-dialog :title="'下单入口配置'" :visible="visible" width="600px" @close="handleClose"
        :close-on-click-modal="false" destroy-on-close>
        <el-form ref="form" :model="formData" label-width="100px">
            <div v-if="rowData.city === '通用'" class="common-config">通用下单入口配置，未单独配置的城市将使用该配置</div>
            
            <!-- 适用城市选择 -->
            <el-form-item v-else style="margin-bottom: 18px;" label="适用的城市" prop="area" :rules="[{ required: true, message: '请选择适用城市', trigger: 'blur' }]">
                <el-cascader style="width: 200px;" filterable v-model="formData.area" :props="props"
                    :options="cityOptions" placeholder="请选择" clearable></el-cascader>
            </el-form-item>

            <!-- 入口配置列表 -->
            <div v-for="(item, index) in formData.portList" :key="index">
                <el-row :gutter="20"  style="margin-bottom: 18px;">
                    <el-col :span="11">
                        <el-form-item :label="`入口${index + 1}：名称`" :prop="`portList.${index}.displayName`"
                            :rules="[{ required: true, message: '请输入名称', trigger: 'blur'}, {min: 2, max: 5, message: '名称长度2-5个字', trigger: 'blur'}]">
                            <el-input v-model="item.displayName" placeholder="请输入" :maxlength="5" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11">
                        <el-form-item label="打开业务" :prop="`portList.${index}.business`"
                            :rules="[{ required: true, message: '请选择业务', trigger: 'change' }]">
                            <el-select v-model="item.business" placeholder="请选择">
                                <el-option v-for="opt in businessType" :key="opt.id" :label="opt.name"
                                    :value="opt.business"
                                    :disabled="formData.portList.some(t => t.business === opt.business)">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="2" class="operations">
                        <el-button type="text" class="delete-btn" @click="handleDelete(index)" v-if="formData.portList.length > 1">删除</el-button>
                    </el-col>
                </el-row>
            </div>

            <!-- 添加入口按钮 -->
            <el-form-item v-if="formData.portList.length < 3">
                <div class="add-btn" @click="handleAddRow">
                    <span class="text-primary">+添加入口</span>
                </div>
            </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取消</el-button>
            <el-button type="primary" @click="handleSubmit">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { cityCodeJson, getCity } from "@/assets/js/city";

export default {
    name: 'ConfigDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'add'
        },
        rowData: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            formData: {
                area: [],
                portList: []
            },
            props: {
                label: "name",
                value: "citycode",
                children: "districts",
            },
            cityOptions: cityCodeJson,
            businessType: [
                {
                    id: 1,
                    name: '定制客运',
                    business: '定制客运'
                },
                {
                    id: 2,
                    name: '旅游包车',
                    business: '旅游包车'
                },
                {
                    id: 3,
                    name: '文旅商品',
                    business: '文旅商品'
                },
            ]
        }
    },
    watch: {
        rowData: {
            handler(newVal) {
                console.log('newVal', newVal)
                if (newVal.cityCode || newVal.city == '通用') {
                    if(newVal.cityCode) {
                        this.formData.area = [getCity(newVal.cityCode).provinceCode, getCity(newVal.cityCode).cityCode]
                    }
                    this.formData.portList = [...newVal.homeConfig]
                }else {
                    this.formData.area = []
                    this.formData.portList = [
                        {
                            displayName: '',
                            business: ''
                        }
                    ]
                }
            },
            immediate: true
        }
    },
    methods: {
        // 删除行
        handleDelete(index) {
            this.formData.portList.splice(index, 1)
        },
        // 添加行
        handleAddRow() {
            this.formData.portList.push({
                displayName: '',
                business: ''
            })
        },
        handleClose() {
            this.$refs.form?.resetFields()
            this.formData = {
                area: [],
                portList: []
            }
            this.$emit('close')
        },
        handleSubmit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return
                }
                if (this.formData.portList.length === 0) {
                    this.$message.warning('请添加至少一个入口')
                    return
                }
                
                const names = this.formData.portList.map(item => item.displayName)
                if (names.some((name, index) => names.indexOf(name) !== index)) {
                    this.$message.warning('展示名称不能重复')
                    return
                }

                this.$emit('submit', this.formData.area[1], this.formData.portList, this.rowData.id)
            })
        }
    }
}
</script>

<style lang="less" scoped>
.operations {
    display: flex;
    align-items: center;
}

.add-btn {
    color: #409EFF;
    cursor: pointer;
    &:hover {
        opacity: 0.8;
    }
}

.delete-btn {
    color: #F56C6C;
}

.common-config {
    color: #999;
    margin-bottom: 18px;
}

:deep(.el-form-item) {
    margin-bottom: 0;
}

:deep(.el-select) {
    width: 100%;
}
</style>
